export default class User {
  constructor(jwt) {
    try {
      this.data = JSON.parse(atob(jwt.split('.')[1]));
    } catch (e) {
      return false;
    }
  }

  static logged() {
    if (localStorage.getItem('jwt')) {
      return new User(localStorage.getItem('jwt'));
    }

    return null;
  }

  papelJWT() {
    const roleRaw = this.data.roles.filter(e => e.startsWith('|PA|'))[0].split('|');
    const roleData = {};

    for (let i = 1; i < roleRaw.length; i += 2) {
      roleData[roleRaw[i]] = roleRaw[i + 1];
    }

    return roleData;
  }

  cpf() {
    return this.data.prevCpf;
  }

  dominio() {
    return this.papelJWT().TD;
  }

  cnpjDoPapel() {
    return this.papelJWT().D.split('#')[1];
  }

  lotacao() {
    return this.data.lotacoes[0];
  }

  lotacaoDoEmissor() {
    return this.papelJWT().LE
      .split(',')[0]
      .split('#')[1];
  }

  mail() {
    return this.data.mail;
  }

  nome() {
    return this.data.name;
  }

  papel() {
    return this.papelJWT().PA;
  }

  isUsuarioRGPS() {
    const papel = this.papel();
    const retorno = papel.split('@')[0];

    if (retorno === 'INSS') {
      return true;
    }
    return false;
  }

  regime() {
    return this.dominio() === 'CNPJ' ? 'rpps' : 'rgps';
  }

  isRPPS() {
    return this.regime() === 'rpps';
  }

  isRGPS() {
    return this.regime() === 'rgps';
  }

  codigosDeRegime() {
    if (this.isRGPS()) {
      return [1, 3];
    }

    return [2, 3];
  }
}



// WEBPACK FOOTER //
// ./src/domain/User.js